import React, { useState } from 'react';
import { XIcon } from 'assests/GmsIcons';

type TCreateDialogProps = {
    isOpen: boolean;
    id: string;
    dialogHeader: string;
    labelName: string;
    value?: string;
    showCancelButton?: boolean;
    actionLabel?: string;
    onClose: () => void;
    onFieldSubmit: (submodelName: string) => void
    showIndicator?: boolean;
}

const CreateSubmodelDialog = ({ isOpen, id, dialogHeader = "", labelName = "", value, onClose, onFieldSubmit, showCancelButton = true, actionLabel, showIndicator = false }: TCreateDialogProps) => {
    const [submodelName, setSubmodelName] = useState(value ?? '');

    const handleOnCreateClick = () => {
        onFieldSubmit(submodelName);
        setSubmodelName("");
    };

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSubmodelName(event.target.value);
    };

    if (!isOpen) return null;

    return (
        <div id={id} className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div id={`${id}-content`} className={`tw-bg-white tw-rounded tw-shadow-md tw-w-1/4 tw-h-auto`}>
                <div id={`${id}-header`} className='tw-flex tw-justify-between tw-items-center'>
                    <div id={`${id}-title-container`} className='tw-flex tw-items-center tw-gap-10'>
                        <h2 id={`${id}-title`} className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3`}>
                            {dialogHeader}
                        </h2>
                    </div>
                    <button
                        id={`${id}-close-btn`}
                        className='tw-mr-2'
                        onClick={onClose}
                    >
                        <XIcon />
                    </button>
                </div>

                <div id={`${id}-divider`} className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`} />

                <div id={`${id}-form-section`} className={`tw-px-3 tw-my-3`}>
                    <label id={`${id}-input-label`} className={`tw-font-normal tw-w-full tw-text-sm tw-ps-1`}>
                        {labelName}
                    </label>
                    <div id={`${id}-input-container`} className="tw-relative">
                        <input
                            id={`${id}-name-input`}
                            className='className={`tw-w-auto tw-min-w-full tw-border tw-border-[#EBECF0] tw-text-xs tw-block tw-py-2 tw-px-3 tw-m-1 tw-bg-[#fff] tw-bg-clip-padding tw-text-[#6B778C] focus:tw-text-gray-700 tw-rounded-[4px] tw-flex-grow tw-font-normal tw-shadow-none`}'
                            onChange={handleNameChange}
                            type="text"
                            value={submodelName}
                            placeholder={"Enter submodel name"}
                        />
                    </div>
                </div>

                <div id={`${id}-footer`} className='tw-flex tw-justify-between tw-item-center tw-px-2 tw-py-3'>
                    <div id={`${id}-indicator`} className='tw-mb-3 tw-ms-2'>
                        {showIndicator ?
                            <label id={`${id}-indicator-text`} className='tw-text-[#747593] tw-text-sm'>
                                Creating your submodel ...
                            </label>
                            : null}
                    </div>
                    <div id={`${id}-actions`} className={`tw-flex tw-gap-2 tw-justify-end`}>
                        {showCancelButton ?
                            <button
                                id={`${id}-cancel-btn`}
                                onClick={onClose}
                                className='samll-outline-btn'
                            >
                                Cancel
                            </button>
                            : null}
                        <button
                            id={`${id}-submit-btn`}
                            disabled={submodelName === ""}
                            onClick={handleOnCreateClick}
                            className={`small-filled-btn`}
                        >
                            {actionLabel ?? 'Create'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateSubmodelDialog